export const TERMS_VERSION = "2026-06";
